import {AfterContentChecked, ChangeDetectorRef, Component, forwardRef, Input, OnInit} from '@angular/core';
import { NG_VALUE_ACCESSOR, Validators, FormControl, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AbstractControlValueAccessor} from '../abstract-control-value-accessor';
import {isMoment, Moment} from 'moment';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Subscription} from 'rxjs';
import {createDateInputMask, formControlErrorKeys, formControlErrorMessage } from '@portal-workspace/grow-ui-library';
import {setupUntilDestroy} from '@portal-workspace/grow-ui-library';
import {delay, tap} from 'rxjs/operators';
import {validAgeValidator, mustBeTodayOrFutureDateValidator} from '@portal-workspace/grow-ui-library';
import moment from 'moment';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import {MARK, Mark} from '@portal-workspace/grow-ui-library/mark';
import { CustomErrorStateMatcher } from '@portal-workspace/grow-ui-library';
import { DatepickerValue } from '@portal-workspace/grow-shared-library';
import { InputMaskModule } from '@ngneat/input-mask';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

import {DisableControlDirective} from '../../directives/disable-control.directive';

@UntilDestroy({arrayName: 'subscriptions'})
@Component({
    selector: 'datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DatepickerComponent), multi: true },
        { provide: MARK, useExisting: forwardRef(() => DatepickerComponent) },
    ],
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, MatDatepickerModule, FormsModule, InputMaskModule, ReactiveFormsModule, DisableControlDirective]
})
export class DatepickerComponent extends AbstractControlValueAccessor<DatepickerValue> implements OnInit, AfterContentChecked, Mark {

  createDateInputMask = createDateInputMask();
  errorStateMatcher = new CustomErrorStateMatcher();
  errorKeys = formControlErrorKeys;
  errorMessage = formControlErrorMessage;
  @Input({required: true}) title?: string;
  @Input({required: false}) allowOnly18YrsPlus: boolean = false;
  @Input({required: false}) override disabled: boolean = false;
  @Input({required: false}) allowOnlyTodayOrFutureDate:boolean =false
  @Input({required: false}) optional: boolean = false;
  @Input({required: false}) required = true;

  subscriptions: Subscription[] = [];

  formControl!: FormControl<string|null>;

  constructor(private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef) {
    super();
  }


  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }


  ngOnInit(): void {
    setupUntilDestroy(this);
    const validators = [];
    if (!this.optional) {
      validators.push(Validators.required);
    }
    if (this.allowOnly18YrsPlus) {
      validators.push(validAgeValidator());
    }
    if (this.allowOnlyTodayOrFutureDate) {
      validators.push(mustBeTodayOrFutureDateValidator());
    }
    this.formControl = this.formBuilder.control(null, validators);
    const sub = this.formControl.valueChanges.pipe(
      delay(0),
      tap(r => {
        // https://github.com/angular/components/issues/11523
        if (this.formControl.valid || (this.formControl.errors as any)?.matDatepickerParse || this.formControl.disabled) {
          // https://github.com/angular/components/issues/11523
          if (!!(this.formControl.errors as any)?.matDatepickerParse?.text) {
            this.formControl.setErrors(null);
          }
          if (typeof r == 'string') {
            const m = moment(r, 'DD/MM/YYYY');
            if (m && m.isValid()) {
              this.propagateChange(m);
            } else {
              this.propagateChange(null);
            }
          } else {
            this.propagateChange(r);
          }
        } else {
          this.propagateChange(null);
        }
      })
    ).subscribe();
    this.subscriptions.push(sub);
  }

  doWriteValue(v: DatepickerValue | null | undefined): void | DatepickerValue {
    if (v && isMoment(v)) {
      this.formControl.setValue(v.format('DD/MM/YYYY'));
    } else if (v == null || v == undefined) {
      this.formControl.setValue(null);
    }
    return undefined;
  }

  onDateChange($event: MatDatepickerInputEvent<Moment>) {
    if ($event && $event.value) {
      this.formControl.setValue($event.value.format('DD/MM/YYYY'));
      this.formControl.updateValueAndValidity();
    }
  }
  mark() {
    this.formControl.markAllAsTouched();
    this.formControl.updateValueAndValidity();
  }

  onDatepickerClosed() {
    this.formControl.markAllAsTouched();
    this.formControl.updateValueAndValidity();
  }
}
